import { inject, Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityTypes } from '@pf/shared-common';
import { ExceptionCauseTypesService } from '@control-tower/platform-wms';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';

@Injectable()
export class ExceptionCauseTypeFacade extends AbstractTypeEntityFacade<ExceptionCauseTypesService> {
    constructor() {
        const typeService = inject(ExceptionCauseTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'exceptionCauseTypeGetAll',
            TypeEntityTypes.ExceptionCauseType
        );
    }
}
